const theme = {

    // Main colors
    $color_1: `#3C3C3C`, // 12
    $color_2: `#FFFFFF`, //25
    $color_3: `#000000`,// 27
    $color_4: `#FDD907`,// 60
    $color_5: `#019A39`,// 61
    $color_6: `#656565`,// 62
    $color_7: `#b13333`,// 63
    $color_8: `#dedede`,
    $color_9: `#166831`,
    $color_10: `#FAE100`, // yellow
    $color_11: `#111111`, // black
    $color_12: `#009A44`, // green
    $color_13: "#009A3F", // unique brand color
    $color_14: `#ffdb01`, // gold
    $color_15: `#da281c`, // red
    $color_16: `#44a30a`, // green
    $color_17: `#282828`, // almost black
    $color_18: '#C6C6C6', // gray,
    $color_19: '#9D9D9D', // gray
    $color_20: `#F3F3F3`, // almost white
    $color_21: `#707070`,
    $color_22: `#C82419`,
    $color_23: `#DEDEDE`,
    $color_24: `#00AF28`,
};

// Cashout full & partial for terminals

theme['$cashoutPanelBackgroundColor'] = theme['$color_1'];
theme['$cashoutFormHeaderBorderColor'] = theme['$color_4'];
theme['$cashoutFormHeaderTextColor'] = theme['$color_2'];
theme['$cashoutFormMainTextColor'] = theme['$color_2'];
theme['$cashoutSliderActiveColor'] = theme['$color_5'];
theme['$cashoutSliderNotActiveColor'] = theme['$color_6'];
theme['$cashoutSliderLabelColor'] = theme['$color_2'];
theme['$cashoutAmountButtonBackgroundColor'] = theme['$color_6'];
theme['$cashoutAmountInputBackgroundColor'] = theme['$color_2'];
theme['$cashoutAmountInputColor'] = theme['$color_3'];

// Cashout code confirmation

theme['$cashoutCodeHeaderBackgroundColor'] = theme['$color_8'];
theme['$cashoutCodePanelBackgroundColor'] = theme['$color_2'];
theme['$cashoutCodeInputBackgroundColor'] = theme['$color_2'];
theme['$cashoutCodeInputTextColor'] = theme['$color_3'];
theme['$cashoutCodeButtonTextColor'] = theme['$color_2'];
theme['$cashoutCodeButtonBackgroundColor'] = theme['$color_9'];
theme['$cashoutConfirmTextMessageColor'] = theme['$color_2'];

// signup user

theme['$signUpHeaderBackgroundColor'] = theme['$color_10'];
theme['$signUpHeaderTextColor'] = theme['$color_11'];
theme['$signUpFormBackgroundColor'] = theme['$color_8'];
theme['$registerFormSubmitBtnBgColor'] = theme['$color_12'];
theme['$registerFormSubmitBtnColor'] = theme['$color_2'];

// gambling controls
theme['$gamblingControlsPrimaryColor'] = theme['$color_13'];


// instant win games list
theme['$iwgPageBackgroundColor'] = theme['$color_17'];
theme['$iwgCardBackgroundColor'] = theme['$color_3'];
theme['$iwgCardTextColor'] = theme['$color_2'];
theme['$iwgImageBackgroundColor'] = theme['$color_3'];
theme['$iwgImageFilterBackgroundColor'] = theme['$color_11']; 
theme['$iwgSessionStatusActiveTextColor'] = theme['$color_14'];
theme['$iwgSessionStatusActiveDotColor'] = theme['$color_14'];
theme['$iwgSessionStatusActiveSessionUserColor'] = theme['$color_16'];
theme['$iwgSessionStatusInActiveTextColor'] = theme['$color_15'];
theme['$iwgSessionStatusInActiveDotColor'] = theme['$color_15'];
theme['$iwgGamesListEmptyColor'] = theme['$color_2'];

// instant win games
theme['$iwgMainColor'] = theme['$color_12'];
theme['$iwgSecondaryColor'] = theme['$color_10'];
theme['$iwgLightTextColor'] = theme['$color_2'];
theme['$iwgDarkTextColor'] = theme['$color_3'];
theme['$iwgRedTextColor'] = theme['$color_15'];
theme['$iwgGreenTextColor'] = theme['$color_16'];
theme['$iwgInfoBorderColor'] = theme['$color_11'];
theme['$iwgPaymentsContainerBgColor'] = theme['$color_8'];
theme['$iwgPaymentSwitchBgColor'] = theme['$color_18'];
theme['$iwgPaymentSwitchTextColor'] = theme['$color_19'];
theme['$iwgPaymentSwitchBgColorActive'] = theme['$color_11'];
theme['$iwgPaymentBgColor'] = theme['$color_20'];

// instant win game page
theme['$iwgGameMainWrapper'] = theme['$color_17'];
theme['$iwgGameNameColor'] = theme['$color_2'];

// Prolong session
theme['$prolongSessionWrapperBackgroundColor'] = theme['$color_23']; 
theme['$prolongSessionWrapperTextColor'] = theme['$color_11'];
theme['$prolongSessionTopRowBackgroundColor'] = theme['$color_10'];
theme['$prolongSessionTopRowDistinctiveTextColor'] = theme['$color_24'];
theme['$prolongSessionMainMessageTextColor'] = theme['$color_19'];

theme['$prolongSessionBalanceLabelColorText'] = theme['$color_11'];
theme['$prolongSessionBalanceBackgroundColor'] = theme['$color_11'];
theme['$prolongSessionBalanceTextColor'] = theme['$color_2'];

theme['$prolongSessionButtonsContainerBorderColor'] = theme['$color_21'];
theme['$prolongSessionButtonTextColor'] = theme['$color_2'];
theme['$sessionContinueButtonBackgroundColor'] = theme['$color_22'];
theme['$prolongSessionLeaveButtonBackgroundColor'] = theme['$color_11'];
theme['$prolongSessionReLoginButtonBackgroundColor'] = theme['$color_24'];
theme['$prolongSessionConfirmButtonBackgroundColor'] = theme['$color_24'];

theme['$prolongSessionErrorTextColor'] = theme['$color_22'];

theme['$prolongSessionInputBackgroundColor'] = theme['$color_2'];
theme['$prolongSessionInputTextColor'] = theme['$color_11'];
theme['$prolongSessionInputBorderColor'] = theme['$color_18'];

theme['$prolongSessionCounterTextColor'] = theme['$color_11'];

// CMS Menu
theme["cmsMenuBackgroundColor"] = theme["$color_13"];
theme["cmsMenuTextColor"] = theme["$color_2"];
theme["cmsMenuTextColorActive"] = theme["$color_4"];

export default theme;